<template>
  <div class="examRoom">
    <div class="left">
      <div class="header">
        <div class="classify" id="type">
          <p>分类：</p>
          <ul>
            <li class="active" @click="queryListByType('', 0)">不限</li>
              <li v-for="(t, key) in examTypeList" @click="queryListByType(t.value, key+1)" :title="t.label">{{t.label}}</li>
          </ul>
        </div>
        <div class="classify" id="category">
          <p>类别：</p>
          <ul>
            <li class="active" @click="queryListByCategory('', 0)">不限</li>
            <li v-for="(l, key) in categorylist" @click="queryListByCategory(l.id, key+1)" :title="l.name">{{ l.name }}</li>
          </ul>
        </div>
      </div>
      <div class="room-text">
        <p v-if="!success" class="tj-shift-notice">{{ message }}</p>
        <template v-else-if="!examlist.length">
          <p class="tj-shift-notice">暂无记录</p>
        </template>
        <template v-else>
          <ul class="clear">
            <li v-for="e in examlist">
              <div class="content">
                <router-link class="tj-link-blue tj-inblock" :to="{name: 'examDetail', params: {id: e.examConfigId}}">
                  <div :style="style(e.examConfig.iconUrl)" class="zoomImage"></div>
                  <div class="text">
                    <div class="title" :title="e.examConfig.name">{{ e.examConfig.name }}</div>
                    <p>
                      <template v-if="e.examConfig.examType == 'Formal'">
                        <span class="formal" title="正式考试">正</span>
                        <span class="iconfont icon-people">
                          <template v-if="e.examConfig.registerNum != null">已有<i>{{ e.examConfig.registerNum }}</i>人报名</template>
                          <template v-else>已有<i>0</i>人报名</template>
                        </span>
                      </template>
                      <template v-else-if="e.examConfig.examType == 'Practice'">
                        <span class="practice" title="模拟练习，可多次练习">练</span>
                      </template>
                    </p>
                  </div>
                </router-link>
              </div>
            </li>
          </ul>
          <pagination :pages="pages" :pageNum="pageNum" @getData="getList"></pagination>
        </template>
      </div>
    </div>
    <!-- <div class="right">
      <div class="study">
        <h4>| 考试动态</h4>
        <ul>
          <li v-for="(infos,key) in info">
            <div class="num" :class="{'one': infos.userRank === 1,'two': infos.userRank === 2,'three': infos.userRank === 3}">{{infos.userRank}}</div>
            <p>{{infos.UserName}}</p>
            <span>{{infos.totalPeriod}}学时</span>
          </li>
        </ul>
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  name: 'examList',
  data() {
    return {
      'success': true,
      'message': '',
      'pageNum': 1,
      'pageSize': 12,
      'pages': 1,
      'examTypeList': [{
        value: 'Formal',
        label: '正式考试'
      },{
        value: 'Practice',
        label: '模拟练习'
      }],
      'examType': '',
      'categoryId': '',
      'categorylist': [],
      'examlist': []
    }
  },
  mounted:function() {
    this.getCategory()
    this.getList(1)
  },
  methods: {
    //查询考试分类
    getCategory() {
      var data = {
        'parentId': -1
      }
      this.$http.post(API_ROOT.system + '/exam/category/queryByParentId', data).then(response => {
        var result = response.data
        if (result.success) {
          this.success = result.success
          this.message = result.msg
          this.categorylist = result.data
        }else {
          alert(result.msg)
        }
      }, response => {
        alert('网络繁忙，请稍后重试！')
      })
    },
    queryListByType(examType, key) {
      $('#type').find('li').eq(key).addClass('active')
      $('#type').find('li').eq(key).siblings().removeClass('active')
      this.examType = examType
      this.pageNum = 1
      var data = {
        'examType': this.examType,
        'parentCategoryId': this.categoryId,
        'pageNum': this.pageNum,
        'pageSize': this.pageSize
      }
      this.$http.post(API_ROOT.system + '/tjkExam/search', data).then(response => {
        var result = response.data
        if (result.success) {
          this.success = result.success
          this.message = result.msg
          this.pageNum = result.data.pageNum == 0 ? 1 : result.data.pageNum
          this.pages = result.data.pages == 0 ? 1 : result.data.pages
          this.examlist = result.data.list != null ? result.data.list : []
        }else {
          alert(result.msg)
        }
      }, response => {
        alert('网络繁忙，请稍后重试！')
      })
    },
    queryListByCategory(categoryId, key) {
      $('#category').find('li').eq(key).addClass('active')
      $('#category').find('li').eq(key).siblings().removeClass('active')
      this.categoryId = categoryId
      this.pageNum = 1
      var data = {
        'examType': this.examType,
        'parentCategoryId': this.categoryId,
        'pageNum': this.pageNum,
        'pageSize': this.pageSize
      }
      this.$http.post(API_ROOT.system + '/tjkExam/search', data).then(response => {
        var result = response.data
        if (result.success) {
          this.success = result.success
          this.message = result.msg
          this.pageNum = result.data.pageNum == 0 ? 1 : result.data.pageNum
          this.pages = result.data.pages == 0 ? 1 : result.data.pages
          this.examlist = result.data.list != null ? result.data.list : []
        }else {
          alert(result.msg)
        }
      }, response => {
        alert('网络繁忙，请稍后重试！')
      })
    },
    getList(num) {
      var data = {
        'examType': this.examType,
        'parentCategoryId': this.categoryId,
        'pageNum': num,
        'pageSize': this.pageSize
      }
      this.$http.post(API_ROOT.system + '/tjkExam/search', data).then(response => {
        var result = response.data
        if (result.success) {
          this.success = result.success
          this.message = result.msg
          this.pageNum = result.data.pageNum
          this.pages = result.data.pages
          this.examlist = result.data.list != null ? result.data.list : []
        }else {
          alert(result.msg)
        }
      }, response => {
        alert('网络繁忙，请稍后重试！')
      })
    },
    //设置图片
    style(iconUrl) {
      return {
        backgroundImage: 'url(' + iconUrl + ')'
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// ./src/page/examList.vue